import { Injectable } from '@angular/core';

import { Subject, BehaviorSubject } from 'rxjs';

interface dialogReturnType {
    authentication: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    step = new BehaviorSubject<string>('get-number');
    mobileStep = new BehaviorSubject<string>('get-number');
    closeWrapperDialog = new Subject<dialogReturnType>();

    constructor() {}

    resetStep() {
        this.step.next('get-number');
        this.mobileStep.next('get-number');
    }

    nextStep(dStep: string, mStep?: string) {
        mStep = mStep || dStep;
        this.step.next(dStep);
        this.mobileStep.next(mStep);
    }
}
